async function updateQuantity(cartChangeUrl, id, diff) {
  const quantityEl = document.getElementById(`${id}-quantity`);
  const oldQuantity = parseInt(quantityEl.innerText, 10);
  const newQuantity = oldQuantity + diff;

  if (newQuantity < oldQuantity) {
    if (newQuantity <= 0) {
      const itemEl = document.getElementById(id);
      itemEl.remove();
    }
  }

  const res = await fetch(cartChangeUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/json`,
    },
    body: JSON.stringify({
      id: id,
      quantity: newQuantity,
      sections: 'cart',
    }),
  });

  if (!res.ok) {
    return;
  }
  quantityEl.innerText = newQuantity;

  const { sections } = await res.json();
  const newDocument = new DOMParser().parseFromString(sections['cart'], 'text/html');

  const cart = document.querySelector('#cart');
  if (cart) {
    cart.innerHTML = newDocument.querySelector('#cart').innerHTML;
  }

  const cartItemCount = newDocument.querySelector('#cart-quantity-template').innerHTML;
  for (const element of document.querySelectorAll('.cart-quantity')) {
    element.innerText = cartItemCount;
  }
  for (const element of document.querySelectorAll('.cart-quantity-dot')) {
    element.innerText = cartItemCount;
    if (cartItemCount === '0') {
      element.classList.add('hidden');
    } else {
      element.classList.remove('hidden');
    }
  }
}
